module.exports = ".cena-details {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/emisija-cena-details/emisija-cena-details.component.scss
// module id = ./src/app/components/emisija-cena-details/emisija-cena-details.component.scss
// module chunks = main